<template>
  <div style="font-size: 0px;">
    <van-image fit="fill" width="100%" height="100%" src="/minio/gyfw/school/嗨学网/topPart.png"/>
    <div style="background-color: #030D30;color: white;padding-left: 10%;font-size: 15px" >登录网址:   <a href="http://www.shupeitong.com" style="color: white" target="_blank">www.shupeitong.com</a></div>
    <van-image fit="fill" width="100%" height="100%" src="/minio/gyfw/school/嗨学网/botPart.png"/>
  </div>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>
